"use client";

import { createTheme } from "@mui/material";

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#BC1918",
      light: "#BC1918",
      dark: "#BC1918",
    },
    secondary: {
      main: "#17232B",
      light: "#17232B",
      dark: "#17232B",
    },
    error: {
      main: "#EB6666",
      light: "#EB6666",
      dark: "#EB6666",
    },
    success: {
      main: "#2BA073",
      light: "#2BA073",
      dark: "#2BA073",
    },
    grey: {
      50: "#F9FAFB",
      100: "#F2F4F7",
      200: "#EAECF0",
      300: "#D0D5DD",
      400: "#98A2B3",
      500: "#667085",
      700: "#344054",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#9E9E9F",
    },
  },
  typography: {
    fontFamily: "var(--font-noto)",
    h1: {
      fontSize: "80px",
      fontWeight: 600,
      color: "#FFFFFF",
    },
    h2: {
      fontSize: "20px",
      color: "#FFFFFF",
      fontWeight: 700,
    },
    h3: {
      fontSize: "48px",
      fontWeight: 700,
      color: "#FFFFFF",
    },
    h4: {
      fontSize: "46px",
      fontWeight: 700,
      color: "#FFFFFF",
    },
    h5: {
      fontSize: "36px",
      fontWeight: 600,
      color: "#FFFFFF",
    },
    body1: {
      fontSize: "24px",
      color: "#FFFFFF",
      fontWeight: 300,
    },
    body2: {
      fontSize: "18px",
      color: "#FFFFFF",
    },
    caption: {
      fontSize: "14px",
      fontWeight: 400,
      color: "#FFFFFF",
    },
    subtitle1: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#FFFFFF",
    },
    subtitle2: {
      fontSize: "16px",
      color: "#FFFFFF",
      fontWeight: 200,
    },
    button: {
      fontSize: "16px",
      fontWeight: 500,
      textTransform: "none",
      color: "#FFFFFF",
    },
  },
  spacing: 4,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: "8px 20px",
          borderRadius: "99px",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
        },
        paper: {
          backgroundColor: "rgba(40, 49, 54, 0.6)",
          backdropFilter: "blur(10px)",
          width: "100vw",
          top: "0 !important",
          left: "0 !important",
          right: "0 !important",
          maxWidth: "100%",
        },
      },
    },
    MuiMenuList: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
        },
      },
    },
  },
});

export default defaultTheme;
